import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import DifferentPaymentTermThanLeaseWarning from '@rental-manager/pages/Onboarding/RentalProtectionDifferentTermWarning/component';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { pageFlows } from '../../pageFlows';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => {
  const { rentalProtectionDisclaimers } = state.payments.landlord.onboarding[propertyId];
  const { editMode } = state.payments.landlord.property.newTermSettings;

  return {
    rentalProtectionDisclaimers,
    editMode,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  onContinue: (editMode) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => editMode && dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => {
        if (editMode) {
          return dispatch(push(baseUrl + paths.dashboard.setupNewTermPage));
        } else {
          return dispatch(push(baseUrl + paths.dashboard.rentAmountPage));
        }
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onContinue: () => {
    const { editMode } = stateProps;
    return dispatchProps.onContinue(editMode);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DifferentPaymentTermThanLeaseWarning);
